import React, { Component } from 'react'
import Input from 'shared-web/src/components/Input'
import IntegrationConnector from '../components/IntegrationConnector'
import { INTERCOM_HELPDOC_URL } from 'constants/HelpDocConstants'

const FindIntercomIdLink = "https://developers.intercom.io/reference#authorization"

class Intercom extends Component {
  state = {
    appId: '',
    apiKey: ''
  }

  getConnectionPayload = () => {
    const { appId, apiKey } = this.state
    return { appId, apiKey }
  }

  renderInputs = () => (
    <div>
    <Input
        placeholder="e.g. 123456"
        label="APP ID"
        valueLink={{
          requestChange: (input) => {
            this.setState({ appId: input })
          },
          value: this.state.appId
        }}
        isValid={ !!this.state.appId }
      />
      <div className="dsg-Body color-gray-dark">
        Need help finding your Intercom API ID? Here’s a <a target="_blank" href={ FindIntercomIdLink }> handy guide</a>
      </div>
      <p>Want more information? <a href={INTERCOM_HELPDOC_URL} target="_blank">Learn More.</a></p>
      <Input
        placeholder="e.g. 123456"
        label="API KEY"
        valueLink={{
          requestChange: (input) => {
            this.setState({ apiKey: input })
          },
          value: this.state.apiKey
        }}
        isValid={ !!this.state.apiKey }
      />
      <div className="dsg-Body color-gray-dark">
        Please use a "Read Only" API Key. Need help finding it? Check out Intercom’s <a target="_blank" href={ FindIntercomIdLink }>helpful instructions</a>
      </div>
    </div>
  )

  render() {
    const { isConnected } = this.props
    return (
      <div>
        <p>Connect your Intercom account to Drift so you can sync your contacts automatically.</p>
        { isConnected ? null : this.renderInputs() }
        <IntegrationConnector
          integrationId="intercom"
          isConnected={isConnected}
          connectionPayload={this.getConnectionPayload()}/>
      </div>
    )
  }
}

export default Intercom



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Intercom.js